import axios from 'axios';
import type { IEmailSupraBillingHistoryBody } from '@/app-package';

const sendSupraBillingHistoryEmail = async (
  body: IEmailSupraBillingHistoryBody,
) => {
  const { data } = await axios.post<void>(
    '/supra/keyholder_invoices/email',
    body,
  );
  return data;
};

export default sendSupraBillingHistoryEmail;
